import { useCallback, useState } from 'react';
import { CompetitorDataType } from 'feature/supplierTabs/general/competitorSupplier/allCompetitorDrawer';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

export const useCompetitorSupplier = () => {
  const [drawerState, setDrawerState] = useState<boolean>(false);
  const [competitorSupplierData, setCompetitorSupplierData] = useState<CompetitorDataType | undefined>(undefined);
  const navigate = useNavigate();
  const onExpand = useCallback((users?: CompetitorDataType) => {
    setCompetitorSupplierData(users);
    setDrawerState((prevState) => !prevState);
  }, []);

  const onRouteChange = useCallback(
    (id: string) => {
      navigate(`${ADMIN_ROUTES.suppliers.view}/${id}/general`);
    },
    [navigate]
  );

  return {
    drawerState,
    onExpand,
    competitorSupplierData,
    onRouteChange,
  };
};
